.root {
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacingMd);
}

.day {
  border-radius: 50%;
  height: 35px;
  width: 35px;
  border: 1px solid var(--paletteNeutral0);
  background: var(--paletteWhite0);
  color: var(--paletteBlue0);

  &.readonly {
    cursor: default;
    background: none;
    border: none;
  }

  &.selected {
    color: var(--paletteWhite0);
    background: var(--paletteBlue0);
    border: none;
  }

  &.disabled {
    color: var(--paletteBlue2);
    cursor: default;
  }
}

.weekdayReadonly {
  display: flex;
  align-items: center;
  gap: var(--spacingSm);
}
